import { useEffect, useState } from "react";
import { getLocalAgentId } from "../utils/localAgent";

export function useLocalAgentId(): string | null {
  const [localId, setLocalId] = useState<string | null>(null);
  useEffect(() => {
    getLocalAgentId().then(setLocalId);
  }, []);
  return localId;
}
